import * as React from 'react';
import cn from 'classnames';
import { useTheme } from '../../../../../../../theme';
import { default as Tooltip } from '../../../../../../../BaseComponents/Tooltip';
import { useTranslation } from 'react-i18next';
import { CdnIcon } from '@shared/ui';

interface Props {
	className?: string;
}

const RecommendedBadge: React.FunctionComponent<Props> = ({ className }) => {
	const { RecommendedBadge: css } = useTheme('Entities').FareGroupV2;
	const { t } = useTranslation('RecommendedBadge');

	return (
		<Tooltip title={t('Best choice')}>
			<div className={cn(css.root, className)}>
				<CdnIcon className={css.icon} icon="Info/Recommended" />
			</div>
		</Tooltip>
	);
};

export default RecommendedBadge;
